import {
  Badge,
  Box,
  Collapse,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CustomAutoComplete from "../contentFeedback/CustomAutoComplete";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useAppSelecter } from "../../hooks/storeHooks";
import { RootState } from "../../store/store";
import { ReviewBadge } from "./SubtopicCard";
import { sum } from "lodash";
import { GridFilterListIcon } from "@mui/x-data-grid";
import FilterMenu from "./FilterMenu";
function TopicSelectionCard({ filters, setFilters ,setLocalFilterState,localFilterState}: any) {
  const [open, setOpen] = useState(true);

  const { masters } = useAppSelecter(
    (state: RootState) => state.contentFeedback
  );
  const commonSx = {
    width: "100%",
    "& .MuiInputBase-root": {
      padding: "5px 7px!important",
      borderRadius: "4px",
    },
    "& .MuiOutlinedInput-input": { padding: "0 !important" },
  };  
  const { exams, goals, sections, topics } = masters;
  return (
    <Box
      // boxShadow="rgba(0, 0, 0, 0.2) 0px 3px 3px -2px, rgba(0, 0, 0, 0.14) 0px 3px 4px 0px, rgba(0, 0, 0, 0.12) 0px 1px 8px 0px"
      sx={{
        // border: "1px solid #ccc",
        borderRadius: "8px",
        color: "#4f4f4f",
        bgcolor: "white",
      }}
    >
      {/* Row Header */}
      <Stack
        direction="row"
        sx={{
          p: "0 8px",
          boxSizing: "border-box",
        }}
        alignItems="center"
        justifyContent="space-between"
      >
        <Box>
          <Typography variant="body1" fontWeight={"bold"}>
            {open ? "Topic Selection Card" : `Topic - ${filters.topic}`}
          </Typography>
        </Box>
        <IconButton size="small" onClick={() => setOpen(!open)}>
          {open ? (
            <KeyboardArrowDownIcon fontSize="small" />
          ) : (
            <KeyboardArrowUpIcon fontSize="small" />
          )}
        </IconButton>
      </Stack>

      <Collapse
        in={open}
        timeout="auto"
        unmountOnExit
        sx={{ mb: open ? "8px" : "0" }}
      >
        <Divider sx={{ mb: "8px" }} />
        <Stack
          direction="column"
          sx={{
            p: "0 8px",
            boxSizing: "border-box",
          }}
        >
          <CustomAutoComplete
            sx={commonSx}
            placeholder="All Exams"
            listLabel="name"
            disabled={exams.length === 1}
            list={exams}
            value={filters.exam ?? ""}
            onChange={(val: any) => {
              setFilters((prev: any) => ({
                ...prev,
                exam: val?.name || "",
                exam_id: val?.id || "",
              }));
              // onPageChange(1);
            }}
            label={""}
            error={false}
            helperText={""}
          />
          <CustomAutoComplete
            sx={{ ...commonSx, margin: "8px 0" }}
            listLabel="name"
            placeholder="All Goals"
            list={goals}
            value={goals.find((s) => s.name === (filters.goal ?? ""))}
            onChange={(val: any) => {
              setFilters((prev: any) => ({
                ...prev,
                goal: val?.name || "",
                goal_id: val?.id || "",
                section: "",
                section_id: "",
                topic: "",
                topic_id: "",
                subtopic: "",
                subtopic_id: "",
                cluster: "",
                cluster_id: "",
              }));
            }}
            label={""}
            error={false}
            helperText={""}
          />
          <CustomAutoComplete
            sx={{ ...commonSx, mb: "8px" }}
            fieldLabel=""
            placeholder="All Sections"
            listLabel="name"
            list={sections}
            value={sections.find((s) => s.name === (filters.section ?? ""))}
            onChange={(val: any) => {
              setFilters((prev: any) => ({
                ...prev,
                section: val ? val.name : "",
                section_id: val ? val.id : "",
                topic: "",
                topic_id: "",
                subtopic: "",
                subtopic_id: "",
                cluster: "",
                cluster_id: "",
              }));
            }}
            error={false}
            helperText={""}
            label={""}
          />
          <Box
            sx={{
              width: "100%",
              gap: "5px",
              display: "flex",
              alignItems: "center",
            }}
          >
          {/* <Box> */}
                      <FilterMenu
        topics={topics}
        subtopics={masters.subtopics}
        clusters={masters.clusters}
        localFilterState={localFilterState}
        setLocalFilterState={setLocalFilterState}
      />
          
            <CustomAutoComplete
              sx={commonSx}
              listLabel="name"
              placeholder="All Topics"
              list={topics.filter((s) =>
            localFilterState.topic !== "all"
              ? localFilterState.topic === "pending"
                ? s.pending + s.save_for_later !== 0
                : s.pending + s.reviewed + s.save_for_later !== 0
              : true
          )}
              value={topics.find((s) => s.name === (filters.topic ?? ""))}
              onChange={(val: any) => {
                setFilters((prev: any) => ({
                  ...prev,
                  topic: val?.name || "",
                  topic_id: val?.id || "",
                  subtopic: "",
                  subtopic_id: "",
                  cluster: "",
                  cluster_id: "",
                }));
              }}
              renderOption={(props: any, option: any) => (
                <li {...props} key={option.id}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      p: 1,
                      width: "100%",
                      whiteSpace: "normal", // ✅ allow wrapping
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography variant="body2" fontWeight="600">
                      {option.name} #{option.id}
                    </Typography>
                    <ReviewBadge
                      reviewed={option.reviewed}
                      total={sum([
                        sum([option.reviewed, option.save_for_later]),
                        option.pending,
                      ])}
                      save_for_later={option.save_for_later}
                      pending={option.pending}
                    />
                  </Box>
                </li>
              )}
              label={""}
              error={false}
              helperText={""}
            />
            {topics.find((s) => s.name === (filters.topic ?? "")) ? (
              <ReviewBadge
                reviewed={
                  topics.find((s) => s.name === (filters.topic ?? ""))?.reviewed
                }
                total={sum([
                  sum([
                    topics.find((s) => s.name === (filters.topic ?? ""))
                      ?.reviewed ?? 0,
                    topics.find((s) => s.name === (filters.topic ?? ""))
                      ?.save_for_later ?? 0,
                  ]),
                  topics.find((s) => s.name === (filters.topic ?? ""))
                    ?.pending ?? 0,
                ])}
                save_for_later={
                  topics.find((s) => s.name === (filters.topic ?? ""))
                    ?.save_for_later
                }
                pending={
                  topics.find((s) => s.name === (filters.topic ?? ""))?.pending
                }
              />
            ) : (
              ""
            )}</Box>
             
        </Stack>
      </Collapse>
    </Box>
  );
}

export default TopicSelectionCard;
